import { AdpAnalytics } from '@adsk/adp-web-analytics-sdk/lib/AdpAnalytics';

export type {
	AdpAnalytics,
	EventType as AdpEventType,
	EVENTS as ADP_EVENTS,
	TrackInfo as AdpTrackInfo,
} from '@adsk/adp-web-analytics-sdk';

export interface AdpComponentProps {
	'adp-click'?: 'true';
	'adp-component-id'?: string;
	'adp-component-type'?: string;
	'adp-component-name'?: string;
	[key: `adp-component-attribute-${string}`]: string;
	[key: `adp-component-metric-${string}`]: string;
}

export type WindowWithAdp = Window & typeof globalThis & { adp: AdpAnalytics };
